export default class AddToCart {
    constructor($el) {
        this.$addToCart = $el;
        this.$decrease = this.$addToCart.querySelector('[data-decrease]');
        this.$increase = this.$addToCart.querySelector('[data-increase]');
        this.$amount = this.$addToCart.querySelector('[data-input-amount]');

        this.decreaseAmount = this.decreaseAmount.bind(this);
        this.increaseAmount = this.increaseAmount.bind(this);

        this.$decrease.addEventListener('click', this.decreaseAmount);
        this.$increase.addEventListener('click', this.increaseAmount);
    }

    decreaseAmount() {
        let value = this.$amount.value;

        value = Math.max(1, value - 1);

        this.$amount.value = value;
    }

    increaseAmount() {
        let value = this.$amount.value;

        value = parseInt(value) + 1;

        this.$amount.value = value;
    }
}